export enum MultiplierEvent{
    ON_INITIALIZED_MULTIPLIER_SYMBOLS = 'onInitializeMultiplierSymbols',
    ON_MULTIPLIER_ANIMATION_END = 'onMultiplierAnimationEnd',
    ON_TOTAL_MULTIPLIER_ANIMATION_END = 'onTotalMultiplierAnimationEnd',
    ON_ALL_MULTIPLIER_ANIMATION_END = 'onAllMultiplierAnimationEnd',
}